// extracted by mini-css-extract-plugin
export default {"mesajContainer":"Loader_mesajContainer__9MV4I","mesaj":"Loader_mesaj__WxHqv"};